import React from 'react';
import styles from './index.module.scss';
import { isSameDay } from '../helpers';
import { ScheduleTimeSlot } from '../../../services/api/types/schedule';

interface DayButtonProps {
  className?: string;
  day: Date;
  activeDay: Date;
  onClick?: (day: Date) => void | Promise<void>;
  availability: ScheduleTimeSlot[];
  showMonth?: boolean;
}

function DayButton({
  className = '',
  day,
  activeDay,
  onClick,
  availability,
  showMonth = false,
}: DayButtonProps) {
  const dayNumber = day.getDate();
  const dayName = day.toLocaleDateString(undefined, { weekday: 'short' });
  const isActive = isSameDay(day, activeDay);

  const disabled = availability.length === 0;

  return (
    <div
      className={`${styles.dayButtonHolder} ${
        disabled ? styles.disabled : ''
      } ${isActive ? styles.active : ''} ${className}`}
    >
      <button
        className={`${styles.dayButton} ${disabled ? styles.disabled : ''} ${
          isActive ? styles.active : ''
        }`}
        disabled={disabled}
        onClick={async () => {
          if (onClick) {
            await onClick(day);
          }
        }}
      >
        <span className={styles.dayNumber}>{dayNumber}</span>
      </button>
      <span className={styles.dayName}>{dayName}</span>
      {showMonth ? (
        <span className={styles.monthName}>
          {day.toLocaleDateString(undefined, {
            month: 'long',
            year: 'numeric',
          })}
        </span>
      ) : null}
    </div>
  );
}

export default DayButton;
